"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Mock = void 0;
const withLag = (timeMS, result) => new Promise((res) => {
    setTimeout(() => res(result), timeMS);
});
const MOCKED_DATA = {
    '/geocode': (params) => withLag(500, params.address
        ? {
            address: params.address,
            long: 25.7,
            lat: 59.28,
        }
        : {
            address: 'Tallinn',
            long: 25.54,
            lat: 58.48,
        }),
    '/carrier/v1/public/services-types': () => ({
        data: {
            items: [
                {
                    code: 11,
                    title: 'Gated yard',
                    type: {
                        code: 3,
                        code_name: 'FEATURE',
                        title: 'FEATURE',
                    },
                    group: 0,
                    price_type: 0,
                    icon: '',
                    unity: null,
                    notes: '',
                },
                {
                    code: 10,
                    title: 'On-site security',
                    type: {
                        code: 3,
                        code_name: 'FEATURE',
                        title: 'FEATURE',
                    },
                    group: 0,
                    price_type: 0,
                    icon: '',
                    unity: null,
                    notes: '',
                },
                {
                    code: 8,
                    title: 'Ramp',
                    type: {
                        code: 3,
                        code_name: 'FEATURE',
                        title: 'FEATURE',
                    },
                    group: 0,
                    price_type: 0,
                    icon: '',
                    unity: null,
                    notes: '',
                },
                {
                    code: 9,
                    title: 'Sprinklers system',
                    type: {
                        code: 3,
                        code_name: 'FEATURE',
                        title: 'FEATURE',
                    },
                    group: 0,
                    price_type: 0,
                    icon: '',
                    unity: null,
                    notes: '',
                },
                {
                    code: 12,
                    title: 'Van ramp',
                    type: {
                        code: 3,
                        code_name: 'FEATURE',
                        title: 'FEATURE',
                    },
                    group: 0,
                    price_type: 0,
                    icon: '',
                    unity: null,
                    notes: '',
                },
                {
                    code: 7,
                    title: 'Liability insurance',
                    type: {
                        code: 0,
                        code_name: 'SPECIAL',
                        title: 'SPECIAL',
                    },
                    group: 0,
                    price_type: 0,
                    icon: '',
                    unity: null,
                    notes: '',
                },
                {
                    code: 6,
                    title: 'Warehouse photo',
                    type: {
                        code: 0,
                        code_name: 'SPECIAL',
                        title: 'SPECIAL',
                    },
                    group: 0,
                    price_type: 0,
                    icon: '',
                    unity: null,
                    notes: '',
                },
                {
                    code: 1,
                    title: 'Warehousing',
                    type: {
                        code: 1,
                        code_name: 'SERVICE',
                        title: 'SERVICE',
                    },
                    group: 1,
                    price_type: 1,
                    icon: '',
                    unity: {
                        id: 1,
                        name: 'Warehousing',
                        days_related: false,
                        code: null,
                        code_name: null,
                        is_active: true,
                    },
                    notes: '',
                },
                {
                    code: 14,
                    title: 'Last mile delivery - dry van',
                    type: {
                        code: 2,
                        code_name: 'DELIVERY',
                        title: 'DELIVERY',
                    },
                    group: 1,
                    price_type: 3,
                    icon: '',
                    unity: null,
                    notes: '',
                },
                {
                    code: 15,
                    title: 'Last mile delivery - flat bed',
                    type: {
                        code: 2,
                        code_name: 'DELIVERY',
                        title: 'DELIVERY',
                    },
                    group: 1,
                    price_type: 3,
                    icon: '',
                    unity: null,
                    notes: '',
                },
                {
                    code: 16,
                    title: 'Last mile delivery - lift gated',
                    type: {
                        code: 2,
                        code_name: 'DELIVERY',
                        title: 'DELIVERY',
                    },
                    group: 1,
                    price_type: 3,
                    icon: '',
                    unity: null,
                    notes: '',
                },
                {
                    code: 18,
                    title: 'Last mile delivery - Sprinter (up to 5 plt)',
                    type: {
                        code: 2,
                        code_name: 'DELIVERY',
                        title: 'DELIVERY',
                    },
                    group: 1,
                    price_type: 3,
                    icon: '',
                    unity: null,
                    notes: '',
                },
                {
                    code: 17,
                    title: 'Last mile delivery - straight truck 26 ft.2',
                    type: {
                        code: 2,
                        code_name: 'DELIVERY',
                        title: 'DELIVERY',
                    },
                    group: 1,
                    price_type: 3,
                    icon: '',
                    unity: null,
                    notes: '',
                },
                {
                    code: 4,
                    title: 'Local delivery',
                    type: {
                        code: 2,
                        code_name: 'DELIVERY',
                        title: 'DELIVERY',
                    },
                    group: 1,
                    price_type: 3,
                    icon: '',
                    unity: null,
                    notes: '',
                },
                {
                    code: 2,
                    title: 'Freeze warehousing',
                    type: {
                        code: 1,
                        code_name: 'SERVICE',
                        title: 'SERVICE',
                    },
                    group: 2,
                    price_type: 1,
                    icon: '',
                    unity: null,
                    notes: '',
                },
                {
                    code: 19,
                    title: 'Frozen warehousing',
                    type: {
                        code: 1,
                        code_name: 'SERVICE',
                        title: 'SERVICE',
                    },
                    group: 2,
                    price_type: 1,
                    icon: '',
                    unity: {
                        id: 1,
                        name: 'Warehousing',
                        days_related: false,
                        code: null,
                        code_name: null,
                        is_active: true,
                    },
                    notes: '',
                },
                {
                    code: 5,
                    title: 'Freeze local delivery',
                    type: {
                        code: 2,
                        code_name: 'DELIVERY',
                        title: 'DELIVERY',
                    },
                    group: 2,
                    price_type: 3,
                    icon: '',
                    unity: null,
                    notes: '',
                },
                {
                    code: 22,
                    title: 'Small Reefer last mile delivery',
                    type: {
                        code: 2,
                        code_name: 'DELIVERY',
                        title: 'DELIVERY',
                    },
                    group: 2,
                    price_type: 2,
                    icon: '',
                    unity: null,
                    notes: '',
                },
                {
                    code: 21,
                    title: 'Std. Reefer last mile delivery',
                    type: {
                        code: 2,
                        code_name: 'DELIVERY',
                        title: 'DELIVERY',
                    },
                    group: 2,
                    price_type: 2,
                    icon: '',
                    unity: null,
                    notes: '',
                },
                {
                    code: 3,
                    title: 'Cross-docking',
                    type: {
                        code: 1,
                        code_name: 'SERVICE',
                        title: 'SERVICE',
                    },
                    group: 3,
                    price_type: 2,
                    icon: '',
                    unity: null,
                    notes: '',
                },
                {
                    code: 25,
                    title: 'AIB last mile delivery - dry van',
                    type: {
                        code: 2,
                        code_name: 'DELIVERY',
                        title: 'DELIVERY',
                    },
                    group: 3,
                    price_type: 3,
                    icon: '',
                    unity: null,
                    notes: '',
                },
                {
                    code: 26,
                    title: 'AIB last mile delivery - lift gated',
                    type: {
                        code: 2,
                        code_name: 'DELIVERY',
                        title: 'DELIVERY',
                    },
                    group: 3,
                    price_type: 3,
                    icon: '',
                    unity: null,
                    notes: '',
                },
                {
                    code: 27,
                    title: 'AIB last mile delivery - straight truck 26 ft.2',
                    type: {
                        code: 2,
                        code_name: 'DELIVERY',
                        title: 'DELIVERY',
                    },
                    group: 3,
                    price_type: 3,
                    icon: '',
                    unity: null,
                    notes: '',
                },
                {
                    code: 28,
                    title: 'Last mile delivery - Sprinter (up to 5 plt)',
                    type: {
                        code: 2,
                        code_name: 'DELIVERY',
                        title: 'DELIVERY',
                    },
                    group: 3,
                    price_type: 3,
                    icon: '',
                    unity: null,
                    notes: '',
                },
                {
                    code: 31,
                    title: 'Alcohol last mile delivery - dry van',
                    type: {
                        code: 2,
                        code_name: 'DELIVERY',
                        title: 'DELIVERY',
                    },
                    group: 4,
                    price_type: 3,
                    icon: '',
                    unity: null,
                    notes: '',
                },
                {
                    code: 33,
                    title: 'Alcohol last mile delivery - lift gated',
                    type: {
                        code: 2,
                        code_name: 'DELIVERY',
                        title: 'DELIVERY',
                    },
                    group: 4,
                    price_type: 3,
                    icon: '',
                    unity: null,
                    notes: '',
                },
                {
                    code: 34,
                    title: 'Alcohol last mile delivery - straight truck 26 ft.2',
                    type: {
                        code: 2,
                        code_name: 'DELIVERY',
                        title: 'DELIVERY',
                    },
                    group: 4,
                    price_type: 3,
                    icon: '',
                    unity: null,
                    notes: '',
                },
                {
                    code: 32,
                    title: 'Last mile delivery - Sprinter (up to 5 plt)',
                    type: {
                        code: 2,
                        code_name: 'DELIVERY',
                        title: 'DELIVERY',
                    },
                    group: 4,
                    price_type: 3,
                    icon: '',
                    unity: null,
                    notes: '',
                },
                {
                    code: 37,
                    title: 'Bonded last mile delivery - dry van',
                    type: {
                        code: 2,
                        code_name: 'DELIVERY',
                        title: 'DELIVERY',
                    },
                    group: 5,
                    price_type: 3,
                    icon: '',
                    unity: null,
                    notes: '',
                },
                {
                    code: 38,
                    title: 'Bonded last mile delivery - flat bed',
                    type: {
                        code: 2,
                        code_name: 'DELIVERY',
                        title: 'DELIVERY',
                    },
                    group: 5,
                    price_type: 3,
                    icon: '',
                    unity: null,
                    notes: '',
                },
                {
                    code: 39,
                    title: 'Bonded last mile delivery - lift gated',
                    type: {
                        code: 2,
                        code_name: 'DELIVERY',
                        title: 'DELIVERY',
                    },
                    group: 5,
                    price_type: 3,
                    icon: '',
                    unity: null,
                    notes: '',
                },
                {
                    code: 40,
                    title: 'Bonded last mile delivery - straight truck 26 ft.2',
                    type: {
                        code: 2,
                        code_name: 'DELIVERY',
                        title: 'DELIVERY',
                    },
                    group: 5,
                    price_type: 3,
                    icon: '',
                    unity: null,
                    notes: '',
                },
                {
                    code: 41,
                    title: 'Last mile delivery - Sprinter (up to 5 plt)',
                    type: {
                        code: 2,
                        code_name: 'DELIVERY',
                        title: 'DELIVERY',
                    },
                    group: 5,
                    price_type: 3,
                    icon: '',
                    unity: null,
                    notes: '',
                },
                {
                    code: 44,
                    title: 'Food last mile delivery - dry van',
                    type: {
                        code: 2,
                        code_name: 'DELIVERY',
                        title: 'DELIVERY',
                    },
                    group: 6,
                    price_type: 3,
                    icon: '',
                    unity: null,
                    notes: '',
                },
                {
                    code: 45,
                    title: 'Food last mile delivery - flat bed',
                    type: {
                        code: 2,
                        code_name: 'DELIVERY',
                        title: 'DELIVERY',
                    },
                    group: 6,
                    price_type: 3,
                    icon: '',
                    unity: null,
                    notes: '',
                },
                {
                    code: 46,
                    title: 'Food last mile delivery - lift gated',
                    type: {
                        code: 2,
                        code_name: 'DELIVERY',
                        title: 'DELIVERY',
                    },
                    group: 6,
                    price_type: 3,
                    icon: '',
                    unity: null,
                    notes: '',
                },
                {
                    code: 47,
                    title: 'Food last mile delivery - straight truck 26 ft.2',
                    type: {
                        code: 2,
                        code_name: 'DELIVERY',
                        title: 'DELIVERY',
                    },
                    group: 6,
                    price_type: 3,
                    icon: '',
                    unity: null,
                    notes: '',
                },
                {
                    code: 48,
                    title: 'Last mile delivery - Sprinter (up to 5 plt)',
                    type: {
                        code: 2,
                        code_name: 'DELIVERY',
                        title: 'DELIVERY',
                    },
                    group: 6,
                    price_type: 3,
                    icon: '',
                    unity: null,
                    notes: '',
                },
                {
                    code: 49,
                    title: 'Foreign Trade Zone warehousing',
                    type: {
                        code: 1,
                        code_name: 'SERVICE',
                        title: 'SERVICE',
                    },
                    group: 7,
                    price_type: 1,
                    icon: '',
                    unity: {
                        id: 1,
                        name: 'Warehousing',
                        days_related: false,
                        code: null,
                        code_name: null,
                        is_active: true,
                    },
                    notes: '',
                },
                {
                    code: 55,
                    title: 'FTZ ast mile delivery - Sprinter (up to 5 plt)',
                    type: {
                        code: 2,
                        code_name: 'DELIVERY',
                        title: 'DELIVERY',
                    },
                    group: 7,
                    price_type: 3,
                    icon: '',
                    unity: null,
                    notes: '',
                },
                {
                    code: 51,
                    title: 'FTZ last mile delivery - dry van',
                    type: {
                        code: 2,
                        code_name: 'DELIVERY',
                        title: 'DELIVERY',
                    },
                    group: 7,
                    price_type: 3,
                    icon: '',
                    unity: null,
                    notes: '',
                },
                {
                    code: 52,
                    title: 'FTZ last mile delivery - flat bed',
                    type: {
                        code: 2,
                        code_name: 'DELIVERY',
                        title: 'DELIVERY',
                    },
                    group: 7,
                    price_type: 3,
                    icon: '',
                    unity: null,
                    notes: '',
                },
                {
                    code: 53,
                    title: 'FTZ last mile delivery - lift gated',
                    type: {
                        code: 2,
                        code_name: 'DELIVERY',
                        title: 'DELIVERY',
                    },
                    group: 7,
                    price_type: 3,
                    icon: '',
                    unity: null,
                    notes: '',
                },
                {
                    code: 54,
                    title: 'FTZ last mile delivery - straight truck 26 ft.2',
                    type: {
                        code: 2,
                        code_name: 'DELIVERY',
                        title: 'DELIVERY',
                    },
                    group: 7,
                    price_type: 3,
                    icon: '',
                    unity: null,
                    notes: '',
                },
                {
                    code: 58,
                    title: 'HAZMAT last mile delivery - dry van',
                    type: {
                        code: 2,
                        code_name: 'DELIVERY',
                        title: 'DELIVERY',
                    },
                    group: 8,
                    price_type: 3,
                    icon: '',
                    unity: null,
                    notes: '',
                },
                {
                    code: 60,
                    title: 'HAZMAT last mile delivery - Sprinter (up to 5 plt)',
                    type: {
                        code: 2,
                        code_name: 'DELIVERY',
                        title: 'DELIVERY',
                    },
                    group: 8,
                    price_type: 3,
                    icon: '',
                    unity: null,
                    notes: '',
                },
                {
                    code: 59,
                    title: 'HAZMAT last mile delivery - straight truck 26 ft.2',
                    type: {
                        code: 2,
                        code_name: 'DELIVERY',
                        title: 'DELIVERY',
                    },
                    group: 8,
                    price_type: 3,
                    icon: '',
                    unity: null,
                    notes: '',
                },
                {
                    code: 67,
                    title: 'Last mile delivery - Sprinter (up to 5 plt)',
                    type: {
                        code: 2,
                        code_name: 'DELIVERY',
                        title: 'DELIVERY',
                    },
                    group: 9,
                    price_type: 3,
                    icon: '',
                    unity: null,
                    notes: '',
                },
                {
                    code: 63,
                    title: 'Organic last mile delivery - dry van',
                    type: {
                        code: 2,
                        code_name: 'DELIVERY',
                        title: 'DELIVERY',
                    },
                    group: 9,
                    price_type: 3,
                    icon: '',
                    unity: null,
                    notes: '',
                },
                {
                    code: 64,
                    title: 'Organic last mile delivery - flat bed',
                    type: {
                        code: 2,
                        code_name: 'DELIVERY',
                        title: 'DELIVERY',
                    },
                    group: 9,
                    price_type: 3,
                    icon: '',
                    unity: null,
                    notes: '',
                },
                {
                    code: 65,
                    title: 'Organic last mile delivery - lift gated',
                    type: {
                        code: 2,
                        code_name: 'DELIVERY',
                        title: 'DELIVERY',
                    },
                    group: 9,
                    price_type: 3,
                    icon: '',
                    unity: null,
                    notes: '',
                },
                {
                    code: 66,
                    title: 'Organic last mile delivery - straight truck 26 ft.2',
                    type: {
                        code: 2,
                        code_name: 'DELIVERY',
                        title: 'DELIVERY',
                    },
                    group: 9,
                    price_type: 3,
                    icon: '',
                    unity: null,
                    notes: '',
                },
                {
                    code: 69,
                    title: 'Temp. Control last mile delivery',
                    type: {
                        code: 2,
                        code_name: 'DELIVERY',
                        title: 'DELIVERY',
                    },
                    group: 10,
                    price_type: 3,
                    icon: '',
                    unity: null,
                    notes: '',
                },
                {
                    code: 72,
                    title: 'Last mile delivery - dry van',
                    type: {
                        code: 2,
                        code_name: 'DELIVERY',
                        title: 'DELIVERY',
                    },
                    group: 11,
                    price_type: 3,
                    icon: '',
                    unity: null,
                    notes: '',
                },
                {
                    code: 73,
                    title: 'Last mile delivery - flat bed',
                    type: {
                        code: 2,
                        code_name: 'DELIVERY',
                        title: 'DELIVERY',
                    },
                    group: 11,
                    price_type: 3,
                    icon: '',
                    unity: null,
                    notes: '',
                },
                {
                    code: 74,
                    title: 'Last mile delivery - lift gated',
                    type: {
                        code: 2,
                        code_name: 'DELIVERY',
                        title: 'DELIVERY',
                    },
                    group: 11,
                    price_type: 3,
                    icon: '',
                    unity: null,
                    notes: '',
                },
                {
                    code: 76,
                    title: 'Last mile delivery - Sprinter (up to 5 plt)',
                    type: {
                        code: 2,
                        code_name: 'DELIVERY',
                        title: 'DELIVERY',
                    },
                    group: 11,
                    price_type: 3,
                    icon: '',
                    unity: null,
                    notes: '',
                },
                {
                    code: 75,
                    title: 'Last mile delivery - straight truck 26 ft.2',
                    type: {
                        code: 2,
                        code_name: 'DELIVERY',
                        title: 'DELIVERY',
                    },
                    group: 11,
                    price_type: 3,
                    icon: '',
                    unity: null,
                    notes: '',
                },
                {
                    code: 79,
                    title: 'Last mile delivery - dry van',
                    type: {
                        code: 2,
                        code_name: 'DELIVERY',
                        title: 'DELIVERY',
                    },
                    group: 12,
                    price_type: 3,
                    icon: '',
                    unity: null,
                    notes: '',
                },
                {
                    code: 80,
                    title: 'Last mile delivery - flat bed',
                    type: {
                        code: 2,
                        code_name: 'DELIVERY',
                        title: 'DELIVERY',
                    },
                    group: 12,
                    price_type: 3,
                    icon: '',
                    unity: null,
                    notes: '',
                },
                {
                    code: 81,
                    title: 'Last mile delivery - lift gated',
                    type: {
                        code: 2,
                        code_name: 'DELIVERY',
                        title: 'DELIVERY',
                    },
                    group: 12,
                    price_type: 3,
                    icon: '',
                    unity: null,
                    notes: '',
                },
                {
                    code: 83,
                    title: 'Last mile delivery - Sprinter (up to 5 plt)',
                    type: {
                        code: 2,
                        code_name: 'DELIVERY',
                        title: 'DELIVERY',
                    },
                    group: 12,
                    price_type: 3,
                    icon: '',
                    unity: null,
                    notes: '',
                },
                {
                    code: 82,
                    title: 'Last mile delivery - straight truck 26 ft.2',
                    type: {
                        code: 2,
                        code_name: 'DELIVERY',
                        title: 'DELIVERY',
                    },
                    group: 12,
                    price_type: 3,
                    icon: '',
                    unity: null,
                    notes: '',
                },
                {
                    code: 88,
                    title: 'Warehousing',
                    type: {
                        code: 1,
                        code_name: 'SERVICE',
                        title: 'SERVICE',
                    },
                    group: 50,
                    price_type: 1,
                    icon: '',
                    unity: {
                        id: 4,
                        name: 'Distribution',
                        days_related: true,
                        code: null,
                        code_name: null,
                        is_active: true,
                    },
                    notes: '',
                },
                {
                    code: 92,
                    title: 'Last mile delivery - dry van',
                    type: {
                        code: 2,
                        code_name: 'DELIVERY',
                        title: 'DELIVERY',
                    },
                    group: 50,
                    price_type: 3,
                    icon: '',
                    unity: {
                        id: 4,
                        name: 'Distribution',
                        days_related: true,
                        code: null,
                        code_name: null,
                        is_active: true,
                    },
                    notes: '',
                },
                {
                    code: 93,
                    title: 'Last mile delivery - flat bed',
                    type: {
                        code: 2,
                        code_name: 'DELIVERY',
                        title: 'DELIVERY',
                    },
                    group: 50,
                    price_type: 3,
                    icon: '',
                    unity: {
                        id: 4,
                        name: 'Distribution',
                        days_related: true,
                        code: null,
                        code_name: null,
                        is_active: true,
                    },
                    notes: '',
                },
                {
                    code: 94,
                    title: 'Last mile delivery - lift gated',
                    type: {
                        code: 2,
                        code_name: 'DELIVERY',
                        title: 'DELIVERY',
                    },
                    group: 50,
                    price_type: 3,
                    icon: '',
                    unity: {
                        id: 4,
                        name: 'Distribution',
                        days_related: true,
                        code: null,
                        code_name: null,
                        is_active: true,
                    },
                    notes: '',
                },
                {
                    code: 96,
                    title: 'Last mile delivery - Sprinter (up to 5 plt)',
                    type: {
                        code: 2,
                        code_name: 'DELIVERY',
                        title: 'DELIVERY',
                    },
                    group: 50,
                    price_type: 3,
                    icon: '',
                    unity: {
                        id: 4,
                        name: 'Distribution',
                        days_related: true,
                        code: null,
                        code_name: null,
                        is_active: true,
                    },
                    notes: '',
                },
                {
                    code: 95,
                    title: 'Last mile delivery - straight truck 26 ft.2',
                    type: {
                        code: 2,
                        code_name: 'DELIVERY',
                        title: 'DELIVERY',
                    },
                    group: 50,
                    price_type: 3,
                    icon: '',
                    unity: {
                        id: 4,
                        name: 'Distribution',
                        days_related: true,
                        code: null,
                        code_name: null,
                        is_active: true,
                    },
                    notes: '',
                },
                {
                    code: 91,
                    title: 'Stop',
                    type: {
                        code: 8,
                        code_name: 'DELIVERY_STOP',
                        title: 'DELIVERY STOP',
                    },
                    group: 50,
                    price_type: 6,
                    icon: '',
                    unity: {
                        id: 4,
                        name: 'Distribution',
                        days_related: true,
                        code: null,
                        code_name: null,
                        is_active: true,
                    },
                    notes: '',
                },
                {
                    code: 90,
                    title: 'Pickup',
                    type: {
                        code: 7,
                        code_name: 'PICKUP',
                        title: 'PICKUP',
                    },
                    group: 50,
                    price_type: 3,
                    icon: '',
                    unity: {
                        id: 4,
                        name: 'Distribution',
                        days_related: true,
                        code: null,
                        code_name: null,
                        is_active: true,
                    },
                    notes: '',
                },
                {
                    code: 84,
                    title: 'Cross docking',
                    type: {
                        code: 1,
                        code_name: 'SERVICE',
                        title: 'SERVICE',
                    },
                    group: 90,
                    price_type: 2,
                    icon: '',
                    unity: {
                        id: 2,
                        name: 'Cross docking',
                        days_related: false,
                        code: null,
                        code_name: null,
                        is_active: true,
                    },
                    notes: '',
                },
                {
                    code: 85,
                    title: 'Restacking light (Shrinked wrapped incl.)',
                    type: {
                        code: 1,
                        code_name: 'SERVICE',
                        title: 'SERVICE',
                    },
                    group: 91,
                    price_type: 2,
                    icon: '',
                    unity: {
                        id: 3,
                        name: 'Loads repair',
                        days_related: false,
                        code: null,
                        code_name: null,
                        is_active: true,
                    },
                    notes: '',
                },
                {
                    code: 86,
                    title: 'Restacking full (Shrinked wrapped incl.)',
                    type: {
                        code: 1,
                        code_name: 'SERVICE',
                        title: 'SERVICE',
                    },
                    group: 92,
                    price_type: 2,
                    icon: '',
                    unity: {
                        id: 3,
                        name: 'Loads repair',
                        days_related: false,
                        code: null,
                        code_name: null,
                        is_active: true,
                    },
                    notes: '',
                },
                {
                    code: 87,
                    title: 'Shrinked wrapped only',
                    type: {
                        code: 1,
                        code_name: 'SERVICE',
                        title: 'SERVICE',
                    },
                    group: 93,
                    price_type: 2,
                    icon: '',
                    unity: {
                        id: 3,
                        name: 'Loads repair',
                        days_related: false,
                        code: null,
                        code_name: null,
                        is_active: true,
                    },
                    notes: '',
                },
            ],
        },
        errors: null,
    }),
    '/carrier/v1/public/search-settings': () => ({
        data: {
            radius: {
                max: 300,
                min: 1,
                default: 50,
            },
            max_plt: 0,
            max_sq_feet: 0,
        },
    }),
    '/carrier/v1/public/warehouse-search': () => ({
        provider: {
            items: [
                {
                    distance: 10,
                    days: 2,
                },
            ],
            page: 0,
            page_count: 1,
            total: 1,
        },
        total: 1,
    }),
};
class Mock {
    static get(url, params) {
        // provider: {
        //     items: IWarehouseSearchListItem[]
        //     page: number
        //     page_count: number
        //     total: number
        // }
        // total?: number
        return MOCKED_DATA[url](params);
    }
}
exports.Mock = Mock;
